module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Bold.88ecd1f0.eot";